/** Deutsche Dezimal-/Geldeingabe: Komma und Punkt, Zwischenstände wie „123,“ bleiben erhalten. */

export function parseGermanDecimal(raw: string): number | null {
  let s = raw.trim().replace(/\s/g, "");
  if (!s || s === "," || s === ".") return null;
  const hasComma = s.includes(",");
  const hasDot = s.includes(".");
  if (hasComma && hasDot) {
    if (s.lastIndexOf(",") > s.lastIndexOf(".")) {
      s = s.replace(/\./g, "").replace(",", ".");
    } else {
      s = s.replace(/,/g, "");
    }
  } else if (hasComma) {
    s = s.replace(",", ".");
  }
  if (s.startsWith(".")) s = `0${s}`;
  if (s.endsWith(".")) s = s.slice(0, -1);
  if (!s) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

export function formatGermanMoneyInput(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "";
  return value.toFixed(2).replace(".", ",");
}

export function isGermanDecimalTyping(raw: string): boolean {
  return raw === "" || /^[\d\s.,]*$/.test(raw);
}
